import React, {
    useEffect,
    useMemo,
    useState,
	useContext
} from "react";

import * as am4core
    from "@amcharts/amcharts4/core";

import { functions }
    from "../../../constants/common-functions";

import OrganisationExtremeChart
    from "./OrganisationExtremeChart";
	
	
import {EMPTY_FILTER_BEAN} from "../../../constants/filter-constants";
	
import {store} from '../../../context/store';

export default function OrganisationExtremePanel({
    organisationIds,
    organisations,
    timelineFrames,
    currentFrame,
	onFrameSelect,
	desks,
	isAnimationMode
}) {

    const [extremes, setExtremes] =
        useState([]);

    const [zoomStart, setZoomStart] =
        useState(null);

    const [zoomEnd, setZoomEnd] =
        useState(null);
		
	const [sharedCursorDate, setSharedCursorDate] =
		useState(null);
			
	const globalState = useContext(store);
	
	const [filterBean, setFilterBean] = useState(EMPTY_FILTER_BEAN);
				
			const queryContext =
				    globalState?.state?.queryContext;

    /*
     * LOAD
     */

	useEffect(function () {

	   

	    if (!organisations || organisations.length === 0) {
	       
	        return;
	    }

	    const body =
	        functions.buildPostBodyFilterBeanQueryContext(
	            filterBean,
	            queryContext
	        );

	  

	    functions.postFilterBeanAjax(
	        "/resolutionsoftwareplatform/dashboard/utilisation/extremes/organisation",
	        body,
	        function (rows) {
	            console.log("EXTREMES", rows);
	            setExtremes(rows || []);
	        }
	    );

	}, [
	    organisations,
	    filterBean,
	    queryContext
	]);

    /*
     * FILTER
     */
	const filteredExtremes =
	    useMemo(function () {

	        if (!Array.isArray(extremes)) {
	            return [];
	        }

	        return extremes.filter(function (e) {
	            return (
	                organisationIds.length === 0
	                || organisationIds.indexOf(
	                    e.organisationId
	                ) >= 0
	                || e.organisationId === -100
	            );
	        });

	    }, [
	        extremes,
	        organisationIds
	    ]);

    /*
     * GROUPED DATA
     */
    const groupedData =
        useMemo(function () {

            const grouped = {};

            /*
             * EXTREMES LOOKUP
             */
            const extremeLookup = {};

            filteredExtremes.forEach(function (e) {

                const key =
                    e.organisationId
                    + "|"
                    + e.observationDate
                    + "|"
                    + e.observationHour;

                extremeLookup[key] = {
                    extremeType:
                        e.extremeType,

                    ranking:
                        e.ranking
                };

            });

            /*
             * TIMELINE FRAMES
             */
            timelineFrames.forEach(function (frame) {

                if (
                    frame == null
                    || frame.date == null
                    || frame.startTime == null
                ) {
                    return;
                }

                const date =
                    frame.date;

                const hour =
                    parseInt(
                        frame.startTime.split(":")[0]
                    );

                /*
                 * SKIP WEEKENDS
                 */
                const jsDate =
                    new Date(
                        date
                        + "T"
                        + String(hour).padStart(2, "0")
                        + ":00:00"
                    );

                const dow =
                    jsDate.getDay();

                if (
                    dow === 0
                    || dow === 6
                ) {
                    return;
                }

                /*
                 * OVERALL
                 */
                if (
                    grouped[-100]
                    == null
                ) {
                    grouped[-100] = [];
                }

                const overallKey =
                    "-100|"
                    + date
                    + "|"
                    + hour;

                const overallExtreme =
                    extremeLookup[
                        overallKey
                    ];

                let overallColumnColor =
                    "rgba(180,180,180,0.28)";

                if (
                    overallExtreme
                    && overallExtreme.extremeType === "PEAK"
                ) {
                    overallColumnColor =
                        "#5a9bd6";
                }

                if (
                    overallExtreme
                    && overallExtreme.extremeType === "TROUGH"
                ) {
                    overallColumnColor =
                        "#f97316";
                }

				/*
				 * REAL OVERALL UTIL
				 */
				let overallOccupied = 0;
				let overallTotal = 0;

				Object.keys(frame.occupancyMap || {}).forEach(function (spaceId) {

				    const occ =
				        frame.occupancyMap[spaceId];

				    overallTotal++;

				    if (occ.occupiedFlag === 1) {
				        overallOccupied += 1;
				    }
				    else if (occ.signsOfLifeFlag === 1) {
				        overallOccupied += 0.5;
				    }

				});

				let overallUtil = 0;

				if (overallTotal > 0) {
				    overallUtil =
				        (overallOccupied / overallTotal) * 100;
				}

				grouped[-100].push({
				    date:
				        jsDate,

				    utilisation:
				        overallUtil,

				    extremeType:
				        overallExtreme
				        ? overallExtreme.extremeType
				        : null,

				    ranking:
				        overallExtreme
				        ? overallExtreme.ranking
				        : null,

				    columnColor:
				        overallColumnColor
				});

                /*
                 * ORGANISATIONS
                 */
                organisations.forEach(function (o) {

                    if (
                        grouped[o.id]
                        == null
                    ) {
                        grouped[o.id] = [];
                    }

                    /*
                     * TODO:
                     * Replace with real org util later
                     */
					/*
					 * REAL ORG UTIL
					 */
					let occupied = 0;
					let total = 0;

					Object.keys(frame.occupancyMap || {}).forEach(function (spaceId) {

					    const occ =
					        frame.occupancyMap[spaceId];

					    const desk =
					        desks.find(function (d) {
					            return Number(d.spaceId) === Number(spaceId);
					        });

					    if (
					        !desk
					        || Number(desk.organisationId) !== Number(o.id)
					    ) {
					        return;
					    }

					    total++;

					    if (occ.occupiedFlag === 1) {
					        occupied += 1;
					    }
					    else if (occ.signsOfLifeFlag === 1) {
					        occupied += 0.5;
					    }

					});

					let util = 0;

					if (total > 0) {
					    util =
					        (occupied / total) * 100;
					}

                    const key =
                        o.id
                        + "|"
                        + date
                        + "|"
                        + hour;

                    const extreme =
                        extremeLookup[key];

                    let columnColor =
                        "rgba(160,160,160,0.22)";

                    if (
                        extreme
                        && extreme.extremeType === "PEAK"
                    ) {
                        columnColor =
                            o.color;
                    }

                    if (
                        extreme
                        && extreme.extremeType === "TROUGH"
                    ) {
                        columnColor =
                            am4core.color(o.color)
                                .lighten(-0.35)
                                .hex;
                    }

                    grouped[o.id].push({

                        date:
                            jsDate,

                        utilisation:
                            util,

                        extremeType:
                            extreme
                            ? extreme.extremeType
                            : null,

                        ranking:
                            extreme
                            ? extreme.ranking
                            : null,

                        columnColor:
                            columnColor
                    });

                });

            });

            return grouped;

        }, [
            filteredExtremes,
            timelineFrames,
            organisations
        ]);

    /*
     * OVERALL
     */
    const overallData =
        groupedData[-100]
        || [];

    return (

        <div
            style={{
                padding: "20px"
            }}
        >

            {/* MASTER */}
            <OrganisationExtremeChart
                chartId=
                    "organisation-master-chart"
                title=
                    "Overall Utilisation"
                color=
                    "#5a9bd6"
                data=
                    {overallData}
                zoomStart=
                    {zoomStart}
                zoomEnd=
                    {zoomEnd}
                isMaster=
                    {true}
                currentFrame=
                {currentFrame}
				onCursorChange={
				    setSharedCursorDate
				}

				cursorDate={
				    sharedCursorDate
				}
				onFrameSelect={onFrameSelect}
				isAnimationMode={isAnimationMode}
				onZoomChange={function (range) {

				    console.log(
				        "ZOOM UPDATE",
				        range
				    );

				    setZoomStart(
				        new Date(range.start)
				    );

				    setZoomEnd(
				        new Date(range.end)
				    );

				}}
            />

            {/* ORG CHARTS */}
			{/* ORG CHARTS */}
			{organisations
			    .filter(function (o) {

			        return (
			            organisationIds.indexOf(o.id) >= 0
			        );

			    })
			    .map(function (o) {

			        const orgData =
			            groupedData[o.id]
			            || [];

			        if (
			            orgData.length === 0
			        ) {
			            return null;
			        }

			        return (

			            <OrganisationExtremeChart
			                key={o.id}
			                chartId={
			                    "org-chart-"
			                    + o.id
			                }
			                title={
			                    o.name
			                }
			                color={
			                    o.color
			                }
			                data={
			                    orgData
			                }
			                zoomStart={
			                    zoomStart
			                }
			                zoomEnd={
			                    zoomEnd
			                }
			                currentFrame={
			                    currentFrame
			                }
			                isMaster={
			                    false
			                }
							onCursorChange={
							    setSharedCursorDate
							}

							cursorDate={
							    sharedCursorDate
							}
							onFrameSelect={onFrameSelect}
							isAnimationMode={isAnimationMode}
			            />
			        );

			    })}

        </div>
    );
}